<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero class="[&_h1]:md:text-[7.5vw]" :hero="hero" />
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" :context="{ cityId: 1 }" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'testing',
})

export default {
  name: 'Testing',
  components: {
    SectionDefault,
    SectionHero,
    OrganismHero,
    Builder,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'ФУНКЦИОНАЛЬНОЕ',
        title2: 'ТЕСТИРОВАНИЕ',
        imagePosition: '!object-top',
        image: 'fitness/functional-testing/hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'fitness/functional-testing/hero.webp',
        breadcrumbs: c.$breadcrumbs.testing(),
      },
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Функциональное тестирование',
            description:
              'Комплексное функциональное тестирование для оценки физического состояния и функциональных возможностей организма.',
            provider: {
              '@type': 'Organization',
              name: 'Encore Fitness',
              url: 'https://encorefitness.ru/',
            },
          },
        },
      ],
    }
  },
}
</script>
